import React from "react"
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

import { RootState } from "@/store/rootReducer";
import { DynamicComponentProps } from "@/types/ModuleComponentProp.type"
import styles from './PositiveReleaseClosure.module.scss';
import { DecimalInput } from "@/components/DecimalInput";
import { APP_CONFIG_KEY } from "@/types/AppConfig.type";



export const PositiveReleaseClosure: React.FC<DynamicComponentProps> = ({ inspection, onValueChange }: DynamicComponentProps) => {
    const { t: translate } = useTranslation()
    const inspectorCommentLength = useSelector((state: RootState) => state.appConfig[APP_CONFIG_KEY.inspectorCommentLength] || 1000);
    const handleDecimalChange = (event: { target: { name: string; value: number | null } }) => {
        if (onValueChange) {
            onValueChange(event as any);
        }
    };

    return (
        <div className={styles.formContainer}>
            <div className={styles.inputRow}>
                <div className={styles.inputGroup}>
                    <DecimalInput
                        id="lotSize"
                        name="lotSize"
                        value={inspection?.lotSize}
                        onChange={handleDecimalChange}
                        label={translate('Quantity Inspected')}
                    />
                </div>
            </div>
            <div className={styles.inputRow}>
                <div className={styles.inputGroup}>
                    <DecimalInput
                        id="removedQuantity"
                        name="removedQuantity"
                        value={inspection?.removedQuantity}
                        onChange={handleDecimalChange}
                        label={translate('Quantity Removed')}
                    />
                </div>
            </div>
            <div className={styles.inputGroup}>
                <label className={styles.lable} htmlFor="inspectorComment">{translate('Inspection Comment')}</label>
                <textarea id="inspectorComment" maxLength={inspectorCommentLength} name='inspectorComment' rows={4} value={inspection?.inspectorComment || ''} onChange={onValueChange}></textarea>
            </div>
        </div>
    );
}